import { createGlobalStyle } from 'styled-components'

export const GlobalPageStyles = createGlobalStyle`
  input:focus {
    border-color: #053dbf !important;
  }

  .custom-label-shared .row .col label {
    margin: auto !important;
    display: block !important;
    font-size: 12px !important;
    margin-bottom: 5px !important;
    font-weight: 600 !important;
    color: #55555f !important;
  }

  .custom-label-shared .row .col select,
  .custom-label-shared .row .col input {
    font-size: 12px !important;
    height: 51px !important;
  }

  .custom-label-shared .row .col textarea {
    font-size: 12px !important;
  }

  .custom-label {
    margin: auto !important;
    display: block !important;
    font-size: 12px !important;
    margin-bottom: 10px !important;
    font-weight: 600 !important;
    color: #55555f !important;
  }

  .invalid-feedback {
    font-size: 12px !important;
  }

  .data-table-extensions > .data-table-extensions-filter > .filter-text {
    background-color: #f8f9fd !important;
    border: 1px solid #d8e0e8;
    padding: 15px 16px !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    transform: translateX(-10%) !important;
  }

  .data-table-extensions > .data-table-extensions-filter > .filter-text::placeholder {
    color: black !important;
  }

  .data-table-extensions > .data-table-extensions-filter > .icon {
    display: none !important;
    padding: 0 !important;
    border: none !important;
  }

  .apexcharts-xcrosshairs.apexcharts-active {
    opacity: 0;
  }
`
